// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --label-font-size: 66px;
  --label-focused-font-size: 12px;
  --label-color: #333333;
  --label-focused-color: #f10c0c;
  --input-border-color: #333333;
  --input-border-color-focused: #0c0c0c;
  --container-margin-top: 0px;
  --input-padding: 8px 10px;
  --label-padding-left: 0px;
  --input-height: 120px;
  --input-padding-top: 0px;
}

.floating-input-container {
  position: relative;
  margin-top: var(--container-margin-top);
}

.floating-input-container input {
  border: 0;
  border-radius: 0;
  border-bottom: 1px solid var(--input-border-color);
  outline: none;
  width: 100%;
  padding: var(--input-padding);
  transition: border-color 0.2s ease-in-out;
}

.floating-input-container input:hover {
  border: 0;
  border-radius: 0;
  border-bottom: 1px solid var(--input-border-color);
  outline: none;
  width: 100%;
  padding: var(--input-padding);
  transition: border-color 0.2s ease-in-out;
}

.floating-input-container .ant-input-affix-wrapper > input.ant-input {
  padding-left: 0 !important;
}

.floating-input-container.small label.floating-label {
  font-size: 10px;
}

.floating-input-container.middle label.floating-label {
  font-size: 12px;
}

.floating-input-container.large label.floating-label {
  font-size: 14px;
}

.inner-payment-term {
  position: relative;
  margin-top: var(--container-margin-top);
}

.inner-payment-term input {
  border: 0;
  border-radius: 0;
  border-bottom: 1px solid var(--input-border-color);
  outline: none;
  width: 100%;
  padding: var(--input-padding);
  transition: border-color 0.2s ease-in-out;
}

.inner-payment-term input:hover {
  border: 0;
  border-radius: 0;
  outline: none;
  width: 100%;
  padding: var(--input-padding);
  transition: border-color 0.2s ease-in-out;
}
.inner-payment-term.ant-input-affix-wrapper > input.ant-input {
  padding-left: 0 !important;
}

.inner-payment-term.small label.floating-label {
  font-size: 10px;
}

.inner-payment-term.middle label.floating-label {
  font-size: 12px;
}

.inner-payment-term.large label.floating-label {
  font-size: 14px;
}

:where(.css-dev-only-do-not-override-cdzvx5).ant-input-affix-wrapper:not(
    .ant-input-disabled
  ):hover {
  z-index: 0 !important;
}
.common-spin-floating-select .ant-spin-dot-holder {
  color: #d2042d !important;
}

label.floating-label {
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  transition: all 0.2s ease-in-out;
  pointer-events: none;
  color: var(--label-color);
  font-size: var(--label-font-size);
}

label.floating-label.focused {
  font-size: var(--label-focused-font-size);
  color: var(--label-focused-color);
  top: var(--label-focused-top, 0px);
  z-index: var(--label-focused-z-index, 0);
  transform: translateY(-100%);
}

.floating-text-area-container.small label.floating-label {
  width: 96%;
  height: 1.4rem;
  background-color: #fcfcfc;
}

.floating-text-area-container.middle label.floating-label {
  height: 1.3rem;
  width: 93%;
  background-color: #fcfcfc;
}

.floating-text-area-container.large label.floating-label {
  width: 96%;
  height: 1.4rem;
  background-color: #fcfcfc;
}

.floating-input-container.small label.floating-label {
  font-size: 10px;
}

.floating-input-container.middle label.floating-label {
  font-size: 12px;
}

.floating-input-container.large label.floating-label {
  font-size: 14px;
}

.floating-input-container .ant-input-outlined:hover {
  border-color: black;
  border-radius: 0;
  border-right: 0;
  border-top: 0;
  border-left: 0;
}

.floating-input-container .ant-input-outlined:hover {
  border-color: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/float-input/FloatInput.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,sBAAsB;EACtB,8BAA8B;EAC9B,6BAA6B;EAC7B,qCAAqC;EACrC,2BAA2B;EAC3B,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kDAAkD;EAClD,aAAa;EACb,WAAW;EACX,6BAA6B;EAC7B,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kDAAkD;EAClD,aAAa;EACb,WAAW;EACX,6BAA6B;EAC7B,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kDAAkD;EAClD,aAAa;EACb,WAAW;EACX,6BAA6B;EAC7B,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,6BAA6B;EAC7B,yCAAyC;AAC3C;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;EAGE,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,gCAAgC;EAChC,oBAAoB;EACpB,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,yCAAyC;EACzC,iCAAiC;EACjC,kCAAkC;EAClC,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[":root {\n  --label-font-size: 66px;\n  --label-focused-font-size: 12px;\n  --label-color: #333333;\n  --label-focused-color: #f10c0c;\n  --input-border-color: #333333;\n  --input-border-color-focused: #0c0c0c;\n  --container-margin-top: 0px;\n  --input-padding: 8px 10px;\n  --label-padding-left: 0px;\n  --input-height: 120px;\n  --input-padding-top: 0px;\n}\n\n.floating-input-container {\n  position: relative;\n  margin-top: var(--container-margin-top);\n}\n\n.floating-input-container input {\n  border: 0;\n  border-radius: 0;\n  border-bottom: 1px solid var(--input-border-color);\n  outline: none;\n  width: 100%;\n  padding: var(--input-padding);\n  transition: border-color 0.2s ease-in-out;\n}\n\n.floating-input-container input:hover {\n  border: 0;\n  border-radius: 0;\n  border-bottom: 1px solid var(--input-border-color);\n  outline: none;\n  width: 100%;\n  padding: var(--input-padding);\n  transition: border-color 0.2s ease-in-out;\n}\n\n.floating-input-container .ant-input-affix-wrapper > input.ant-input {\n  padding-left: 0 !important;\n}\n\n.floating-input-container.small label.floating-label {\n  font-size: 10px;\n}\n\n.floating-input-container.middle label.floating-label {\n  font-size: 12px;\n}\n\n.floating-input-container.large label.floating-label {\n  font-size: 14px;\n}\n\n.inner-payment-term {\n  position: relative;\n  margin-top: var(--container-margin-top);\n}\n\n.inner-payment-term input {\n  border: 0;\n  border-radius: 0;\n  border-bottom: 1px solid var(--input-border-color);\n  outline: none;\n  width: 100%;\n  padding: var(--input-padding);\n  transition: border-color 0.2s ease-in-out;\n}\n\n.inner-payment-term input:hover {\n  border: 0;\n  border-radius: 0;\n  outline: none;\n  width: 100%;\n  padding: var(--input-padding);\n  transition: border-color 0.2s ease-in-out;\n}\n.inner-payment-term.ant-input-affix-wrapper > input.ant-input {\n  padding-left: 0 !important;\n}\n\n.inner-payment-term.small label.floating-label {\n  font-size: 10px;\n}\n\n.inner-payment-term.middle label.floating-label {\n  font-size: 12px;\n}\n\n.inner-payment-term.large label.floating-label {\n  font-size: 14px;\n}\n\n:where(.css-dev-only-do-not-override-cdzvx5).ant-input-affix-wrapper:not(\n    .ant-input-disabled\n  ):hover {\n  z-index: 0 !important;\n}\n.common-spin-floating-select .ant-spin-dot-holder {\n  color: #d2042d !important;\n}\n\nlabel.floating-label {\n  position: absolute;\n  top: 50%;\n  left: 10px;\n  transform: translateY(-50%);\n  transition: all 0.2s ease-in-out;\n  pointer-events: none;\n  color: var(--label-color);\n  font-size: var(--label-font-size);\n}\n\nlabel.floating-label.focused {\n  font-size: var(--label-focused-font-size);\n  color: var(--label-focused-color);\n  top: var(--label-focused-top, 0px);\n  z-index: var(--label-focused-z-index, 0);\n  transform: translateY(-100%);\n}\n\n.floating-text-area-container.small label.floating-label {\n  width: 96%;\n  height: 1.4rem;\n  background-color: #fcfcfc;\n}\n\n.floating-text-area-container.middle label.floating-label {\n  height: 1.3rem;\n  width: 93%;\n  background-color: #fcfcfc;\n}\n\n.floating-text-area-container.large label.floating-label {\n  width: 96%;\n  height: 1.4rem;\n  background-color: #fcfcfc;\n}\n\n.floating-input-container.small label.floating-label {\n  font-size: 10px;\n}\n\n.floating-input-container.middle label.floating-label {\n  font-size: 12px;\n}\n\n.floating-input-container.large label.floating-label {\n  font-size: 14px;\n}\n\n.floating-input-container .ant-input-outlined:hover {\n  border-color: black;\n  border-radius: 0;\n  border-right: 0;\n  border-top: 0;\n  border-left: 0;\n}\n\n.floating-input-container .ant-input-outlined:hover {\n  border-color: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
